import { VisibilityScopeValue } from "../../../components/ui/VisibilityScope";

export type SystemTypeId = "pt" | "npt";
export type SystemType = {
  id: SystemTypeId;
  name: string;
  description: string;
  order: number;
  image?: string;
};

export type AdminSystemType = SystemType & {
  nameIt: string | null;
  nameDe: string | null;
  nameEs: string | null;
  nameFr: string | null;
  descriptionIt: string | null;
  descriptionDe: string | null;
  descriptionEs: string | null;
  descriptionFr: string | null;
  visibility: VisibilityScopeValue;
};

export const isPassingThrough = (systemType: SystemType | null): boolean => systemType?.id === "pt";

// export type InsertSystemTypeBody = Omit<AdminSystemType, "id" | "image" | "isPassingThrough">;

export type UpdateSystemTypeRemoveImageBody = Omit<AdminSystemType, "id" | "image" | "isPassingThrough"> & {
  removeImage?: boolean;
};
export type UpdateSystemTypeNewImageBody = Omit<AdminSystemType, "id" | "isPassingThrough">;
